import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import {
	AlarisBalanceService,
	AlarisCellContextDirective,
	AlarisComplexTooltipDirective,
	AlarisCostComponent,
	AlarisIconDirective,
	AlarisLinkComponent,
	AlarisProgressLineComponent,
	AlarisTagComponent,
	AlarisTooltipDirective,
	ChannelUtilsService,
	DateFormatPipe,
	SharedTemplatesService,
	TableCellInput,
} from '@campaign-portal/components-library';
import { CampaignStatus } from '@campaign-portal/namespace/entities/campaigns/specs';
import { exist } from '@campaign-portal/namespace/common/id';
import { CampaignUtilsService } from '@shared/services/campaign-utils.service';
import { CampaignEntity } from '@shared/types';
import { CampaignProgressTooltipComponent } from './campaign-progress-tooltip/campaign-progress-tooltip.component';
import { CampaignComponent } from './campaign/campaign.component';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { UrlShortenerUtilsService } from '@shared/services';
import { SenderPipe } from '@shared/repo';
import { CampaignTemplateTooltipComponent } from './campaign-template-tooltip/tooltip.component';

@Component({
	selector: 'app-campaigns-templates',
	templateUrl: './campaigns-templates.component.html',
	styleUrls: ['./campaigns-templates.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CampaignComponent,
		AlarisCellContextDirective,
		AlarisTagComponent,
		TranslateModule,
		AlarisProgressLineComponent,
		AlarisComplexTooltipDirective,
		DecimalPipe,
		AlarisLinkComponent,
		AlarisTooltipDirective,
		SenderPipe,
		AlarisIconDirective,
		AlarisCostComponent,
		DateFormatPipe,
	],
	standalone: true,
})
export class CampaignsTemplatesComponent implements AfterViewInit, OnDestroy {
	public readonly campaignCtx!: CampaignEntity<exist>;

	@ViewChild('campaignSenders') readonly campaignSenders!: TemplateRef<TableCellInput>;
	@ViewChild('campaignChannel') readonly campaignChannel!: TemplateRef<TableCellInput>;

	@ViewChild('campaign') readonly campaign!: TemplateRef<TableCellInput>;
	@ViewChild('status') readonly status!: TemplateRef<TableCellInput>;
	@ViewChild('progress') readonly progress!: TemplateRef<TableCellInput>;
	@ViewChild('shortUrl') readonly shortUrl!: TemplateRef<TableCellInput>;
	@ViewChild('recipients') readonly recipients!: TemplateRef<TableCellInput>;
	@ViewChild('cost') readonly cost!: TemplateRef<TableCellInput>;
	@ViewChild('startDate') readonly startDate!: TemplateRef<TableCellInput>;
	@ViewChild('finishedDate') readonly finishedDate!: TemplateRef<TableCellInput>;
	@ViewChild('lastUpdated') readonly lastUpdated!: TemplateRef<TableCellInput>;

	readonly CampaignStatus = CampaignStatus;
	readonly CampaignProgressTooltipComponent = CampaignProgressTooltipComponent;
	protected readonly CampaignTemplateTooltipComponent = CampaignTemplateTooltipComponent;

	constructor(
		public readonly bs: AlarisBalanceService,
		public readonly campaignUtils: CampaignUtilsService,
		public readonly shortenerUtils: UrlShortenerUtilsService,
		public readonly cu: ChannelUtilsService,
		private readonly templates: SharedTemplatesService<TableCellInput>
	) {}

	ngAfterViewInit(): void {
		this.templates.share({
			campaign: this.campaign,
			campaignSenders: this.campaignSenders,
			status: this.status,
			progress: this.progress,
			shortUrl: this.shortUrl,
			recipients: this.recipients,
			cost: this.cost,
			startDate: this.startDate,
			finishedDate: this.finishedDate,
			campaignChannel: this.campaignChannel,
			lastUpdated: this.lastUpdated,
		});
	}

	ngOnDestroy(): void {
		this.templates.clear();
	}
}
